export const categories = [
    {
      id: 1,
      name: 'Romantic',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 2,
      name: 'Adventure',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 3,
      name: 'Mystery',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 4,
      name: 'Science Fiction',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 5,
      name: 'Fantasy',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 6,
      name: 'Historical Fiction',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 7,
      name: 'Biography',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 8,
      name: 'Self-Help',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 9,
      name: 'Business',
      image: './images/Blogs/HeroImage.png',
    },
    {
      id: 10,
      name: 'Children',
      image: './images/Blogs/HeroImage.png',
    }
  ];